import { createAsyncThunk } from "@reduxjs/toolkit";
import { AdminSendEmailVerification } from "helpers/api_method";

export const adminSendEmailVerification = createAsyncThunk("adminEmailVerification/adminSendEmailVerification", async (event: any, { rejectWithValue }) => {
    try {
        const response = (await AdminSendEmailVerification(event)) as any;
        
        // The interceptor returns the full response object
        // Backend returns: { success: true, message: "...", data: {...} }
        if (response && response.success === true) {
            return {
                success: true,
                message: response.message,
                data: response.data
            };
        } else if (response && response.success === false) {
            return rejectWithValue(response.message || "Failed to send email verification");
        }
        // If response doesn't have expected structure, treat as success
        return { success: true, data: response };
    } catch (error: any) {
        const errorMessage = error?.response?.data?.message || error?.message || "Failed to send email verification";
        return rejectWithValue(errorMessage);
    }
});
